import { ORGANIZING_TEAM } from "@/data/content";
import Reveal from "@/components/Reveal";

export default function OrganizingTeam() {
  return (
    <section id="team" className="py-24 sm:py-32 px-5 sm:px-8 lg:px-12 bg-paper">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.22em] text-crimson font-semibold mb-5">07 · Organizing Team</p>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter leading-[0.95] max-w-3xl">
            The people behind BioInnovate.
          </h2>
        </Reveal>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-ink/10 border border-ink/10">
          {ORGANIZING_TEAM.map((group, i) => (
            <Reveal key={group.role} delay={(i % 4) * 0.05}>
              <div className="bg-paper p-6 h-full">
                <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-crimson font-semibold mb-4">{group.role}</p>
                <ul className="space-y-2">
                  {group.names.map((n) => (
                    <li key={n} className="text-ink/80 text-[15px] leading-snug">{n}</li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
